export const JASMINE_PATH = require.resolve('jest-jasmine2/build/jasmine/jasmineLight');
export const SETUP_GLOBAL_PATHS = require.resolve('jest-jasmine2/build/setup_jest_globals');
export const JEST_EXPECT_PATH = require.resolve('jest-jasmine2/build/jestExpect');
export const CUCUMBER_PATH = require.resolve('cucumber/lib/index');
export const CUCUMBER_JEST_PATH = require.resolve('jest-runner-cucumber/dist/utils/runTest');
export const TEST_WORKER_PATH = require.resolve('jest-runner-cucumber/dist/testWorker');
